<template>
    <b-row class="pe-0">
        <b-col cols="5">
            <b-row>
                <b-col class="pe-0">
                    <p class="sub-label">Sale Price</p>
                </b-col>
                <b-col class="px-0">
                    <p class="sub-value">{{ itemdata.SalesPrice }}</p>
                </b-col>
            </b-row>
            <b-row>
                <b-col class="pe-0">
                    <p class="sub-label">Tax</p>
                </b-col>
                <b-col class="px-0">
                    <p class="sub-value">{{ itemdata.PurchasePercentage }}</p>
                </b-col>
            </b-row>
        </b-col>
        <b-col cols="4">
            <b-row>
                <b-col class="pe-0">
                    <p class="sub-label">Pur. Price</p>
                </b-col>
                <b-col class="px-0">
                    <p class="sub-value">{{ itemdata.PurchasePrice }}</p>
                </b-col>
            </b-row>
            <!-- <b-row>
                <b-col class="pe-0">
                    <p class="sub-label">Margins</p>
                </b-col>
                <b-col class="px-0">
                    <p class="sub-value">{{ itemdata.Margins }}%</p>
                </b-col>
            </b-row> -->
        </b-col>
        <b-col cols="3" class="pe-0">
            <div class="mrp-box">
                <p class="mrp-label">MRP</p>
                <p class="mrp-value">{{ itemdata.MRP }}</p>
            </div>
        </b-col>
    </b-row>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { object } from 'yup';
export default defineComponent({
    props: {
        itemdata: {
            type: Object,
            default: ""
        }
    },
    setup() {
        return {

        }
    }

})
</script>

<style lang="scss" scoped>
.sub-label {
    text-align: left;
    font-size: 10px;
    color: #999999;
}

.sub-value {
    text-align: right;
    font-size: 11px;
    font-weight: 500;
    color: #000000;
}

.mrp-box {
    background-color: #EAECF1;
    border-radius: 7px;
    padding: 5px 10px;

    .mrp-label {
        text-align: left;
        font-size: 10px;
        color: #999999;
    }

    .mrp-value {
        text-align: left;
        font-size: 12px;
        font-weight: 600;
        color: #000000;
    }
}
</style>